import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card } from 'antd'
import { useParams } from 'react-router'
import { actions } from '../../../../../store/reducers/assignments.reducer'
import FeedbackFromStudentsTable from './FeedbackFromStudentsTable'
import FeedbackFromStudentsStatistics from './FeedbackFromStudentsStatistics'
import assignmentSelectors from '../../../../../store/selectors/assignment.selectors'
import { useDocumentTitle } from '../../../../../hooks/useDocumentTitle'

const FeedbackFromStudentsSection = () => {
    const assignmentName = useSelector(assignmentSelectors.name)
    useDocumentTitle(`${assignmentName || ''} Students feedback`)

    const dispatch = useDispatch()

    const { token } = useParams()

    const [isWaitingForFeedbackFromStudents, setIsWaitingForFeedbackFromStudents] = useState(false)

    useEffect(() => {
        ;(async () => {
            setIsWaitingForFeedbackFromStudents(true)
            await dispatch(actions.fetchAssignmentStudentsFeedback(token))
            setIsWaitingForFeedbackFromStudents(false)
        })()
    }, [token])

    return (
        <Card title='Student feedback'>
            <FeedbackFromStudentsStatistics />
            <FeedbackFromStudentsTable isWaitingForFeedbackFromStudents={isWaitingForFeedbackFromStudents} />
        </Card>
    )
}

export default FeedbackFromStudentsSection
